const AdvantageIcon = ({ size, color, styles }) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
      style={styles}
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M2890 5114 c-19 -2 -78 -9 -130 -15 -374 -42 -771 -181 -1103 -387
-340 -210 -667 -538 -880 -883 -422 -685 -518 -1524 -260 -2288 22 -63 46
-119 55 -125 12 -7 144 40 565 203 301 118 554 219 562 227 12 11 10 24 -13
88 -47 134 -67 249 -73 423 -6 171 3 267 38 408 115 460 451 845 885 1015 459
179 963 127 1363 -141 50 -33 99 -59 109 -57 16 3 694 870 727 929 18 34 13
40 -95 116 -361 252 -763 409 -1205 469 -106 14 -474 27 -545 18z'
        />
        <path
          d='M2660 3684 c-115 -38 -259 -111 -360 -182 -36 -26 -111 -92 -168
-149 -131 -130 -132 -135 -6 -178 50 -17 118 -48 151 -68 33 -20 67 -37 76
-37 8 0 39 20 69 44 84 68 173 123 297 182 l113 55 -8 72 c-5 40 -8 117 -9
172 0 55 -4 106 -8 113 -12 18 -31 15 -147 -24z'
        />
        <path
          d='M3170 3295 c-452 -67 -835 -338 -1015 -718 -24 -50 -56 -137 -71
-192 -75 -283 -19 -748 127 -1036 59 -118 58 -195 -8 -320 -38 -74 -84 -132
-262 -329 -167 -185 -194 -249 -133 -310 45 -44 196 -76 307 -65 280 29 513
200 620 454 57 136 69 216 70 461 0 242 3 258 57 306 60 55 127 38 218 -54
144 -146 218 -363 279 -809 14 -102 28 -161 50 -215 111 -265 406 -417 886
-458 392 -33 416 8 143 245 -280 244 -388 368 -388 449 0 26 30 55 113 110
157 105 180 246 58 364 -22 21 -111 88 -198 147 -227 156 -350 252 -396 310
l-40 50 549 5 c302 3 555 9 562 13 15 10 17 388 2 522 -46 406 -316 765 -713
949 -254 118 -546 161 -817 121z m-242 -1152 c134 -100 76 -295 -88 -295 -171
0 -221 236 -65 308 40 19 119 12 153 -13z m1432 -22 c41 -21 80 -74 80 -108 0
-42 -27 -89 -63 -111 -34 -22 -39 -22 -558 -22 -493 0 -526 1 -552 19 -42 27
-60 59 -61 107 -1 50 23 88 74 115 32 18 67 19 540 19 473 0 508 -1 540 -19z'
        />
      </g>
    </svg>
  );
};

export default AdvantageIcon;
